import { useEffect, useCallback, useState } from "react"

//PrimeReact
import { Tree } from "primereact/tree"

//RefModules
import { findServiceCategoryByKey } from "../sharedFunctions"

//styles
import mapSearchStyles from "../../../../styles/referrals/ReferralEntityMapSearch.module.css"

export default function MapSearchSideBarCatFilter({
  categoryList,
  selectedCategories,
  onSelectedCategoriesChanged,
}) {
  const [tempSelectedCategories, setTempSelectedCategories] = useState(null)
  const [expandedKeys, setExpandedKeys] = useState({})
  //Use flag to allow expansion at a later stage.
  const doExpandAll = false

  const onCategorySelectionChange = (selection) => {
    let selected = []

    Object.keys(selection).forEach((key) => {
      if (selection[key].checked) {
        const node = findServiceCategoryByKey(key, categoryList)
        selected = [...selected, node]
      }
    })

    onSelectedCategoriesChanged(selected)
    setTempSelectedCategories(selection)
  }

  const expandNode = useCallback((node, _expandedKeys) => {
    if (node.children && node.children.length) {
      _expandedKeys[node.key] = true

      for (let child of node.children) {
        expandNode(child, _expandedKeys)
      }
    }
  }, [])

  useEffect(() => {
    let _expandedKeys = {}
    if (doExpandAll) {
      for (let node of categoryList) {
        expandNode(node, _expandedKeys)
      }
    } else {
      for (let node of categoryList) {
        _expandedKeys[node.key] = true
      }
    }

    setExpandedKeys(_expandedKeys)
  }, [categoryList, doExpandAll, expandNode])

  useEffect(() => {
    if (selectedCategories?.length > 0 && !!!tempSelectedCategories) {
      let selectCats = {}
      let paths = []

      selectedCategories.forEach((cat) => {
        const newCat = {}
        newCat[cat.key] = {
          checked: true,
          partialChecked: false,
        }

        paths = [...paths, ...cat.path]

        Object.assign(selectCats, newCat)
      })

      new Set(paths).forEach((path) => {
        if (!Object.keys(selectCats).some((key) => key === path)) {
          const newCat = {}
          newCat[path] = {
            checked: false,
            partialChecked: true,
          }
          Object.assign(selectCats, newCat)
        }
      })

      setTempSelectedCategories(selectCats)
    }
  }, [selectedCategories, tempSelectedCategories])

  const NodeTemplate = (node, options) => {
    if (
      !!options.props.selectionKeys &&
      Object.keys(options.props.selectionKeys).includes(`${node.key}`)
    ) {
      if (options.props.selectionKeys[node.key].partialChecked) {
        return (
          <span
            className={`${options.className} ${mapSearchStyles.categoryFilterTreePartialCheck}`}
          >
            {node.label}
          </span>
        )
      } else if (options.props.selectionKeys[node.key].checked) {
        return (
          <span
            className={`${options.className} ${mapSearchStyles.categoryFilterTree}`}
          >
            {node.label}
          </span>
        )
      }
    }

    return (
      <span
        className={`${options.className} ${mapSearchStyles.categoryFilterTree}`}
      >
        {node.label}
      </span>
    )
  }

  return (
    <div style={{ minHeight: "300" }}>
      <Tree
        value={categoryList}
        selectionMode="checkbox"
        filter
        filterMode="strict"
        selectionKeys={tempSelectedCategories}
        onSelectionChange={(e) => onCategorySelectionChange(e.value)}
        expandedKeys={expandedKeys}
        onToggle={(e) => setExpandedKeys(e.value)}
        nodeTemplate={NodeTemplate}
      />
    </div>
  )
}
